import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const DateRangeEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 128 128"
    data-test="date-range-empty-state"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M115.84 71.808a51.193 51.193 0 0 0-19.044-39.837 51.2 51.2 0 0 0-78.8 60.957h93.287a50.996 50.996 0 0 0 4.557-21.12Z"
        fill={colors.grey5}
      />
      <path d="M14.08 92.928h99.84M8.32 92.928h3.2M116.48 92.928h3.2" stroke={colors.purple100} />
      <path
        d="M60.914 104.366c0 2.103-6.692 3.996-15.009 3.996-8.316 0-15.002-1.788-15.002-3.996 0-2.209 6.692-3.997 15.002-3.997 8.311 0 15.01 1.893 15.01 3.997Z"
        fill={colors.grey5}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.936 101.347v-9.334c0-.736.597-1.333 1.333-1.333h17.334c.736 0 1.333.597 1.333 1.333v9.334"
        fill={colors.purple10}
      />
      <path
        d="M37.936 101.347v-9.334c0-.736.597-1.333 1.333-1.333h17.334c.736 0 1.333.597 1.333 1.333v9.334"
        stroke={colors.purple100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.823 104.013H36.048a.654.654 0 0 1-.65-.826 2.665 2.665 0 0 1 2.534-1.84h20c1.154 0 2.176.743 2.533 1.84a.656.656 0 0 1-.642.826Z"
        fill={colors.purple100}
        stroke={colors.purple100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.936 82.013v-2.588a1.334 1.334 0 0 1 1.49-1.325 12.667 12.667 0 0 1 11.089 11.09 1.333 1.333 0 0 1-1.324 1.49h-2.588"
        fill={colors.purple50}
      />
      <path
        d="M47.936 82.013v-2.588a1.334 1.334 0 0 1 1.49-1.325 12.667 12.667 0 0 1 11.089 11.09 1.333 1.333 0 0 1-1.324 1.49h-2.588"
        stroke={colors.purple100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m61.39 80.997-2.813 2.812 2.812-2.812Z"
        fill={colors.purple100}
      />
      <path
        d="m61.39 80.997-2.813 2.812C57.452 82.154 56.66 81.362 55 80l2.5-2.5c1.311 1.458 2.147 2.198 3.89 3.498Z"
        fill={colors.purple100}
      />
      <path
        clipRule="evenodd"
        d="m61.39 80.997-2.813 2.812 2.812-2.812Z"
        stroke={colors.purple100}
      />
      <path
        d="m61.39 80.997-2.813 2.812C57.452 82.154 56.66 81.362 55 80l2.5-2.5c1.311 1.458 2.147 2.198 3.89 3.498ZM54.807 80.037l2.81-2.81"
        stroke={colors.purple100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m59.724 74.184 4.714 4.714c.26.26.26.682 0 .943l-.471.471a2.667 2.667 0 0 1-3.772 0l-1.885-1.886a2.667 2.667 0 0 1 0-3.77l.471-.472c.26-.26.683-.26.943 0v0Z"
        fill={colors.purple10}
        stroke={colors.purple100}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.27 101.347v-6c0-.369.298-.667.666-.667h4c.368 0 .667.298.667.667v6"
        fill={colors.cyan10}
      />
      <path
        d="M45.27 101.347v-6c0-.369.298-.667.666-.667h4c.368 0 .667.298.667.667v6M41.27 96.347c.183 0 .333.149.333.333M40.933 96.68a.332.332 0 0 1 .334-.333M41.27 97.013a.332.332 0 0 1-.334-.333"
        stroke={colors.purple100}
      />
      <path
        d="M41.6 96.68c0 .184-.15.333-.333.333M54.603 96.347c.184 0 .333.149.333.333M54.267 96.68a.332.332 0 0 1 .333-.333M54.603 97.013a.332.332 0 0 1-.334-.333"
        stroke={colors.purple100}
      />
      <path d="M54.933 96.68c0 .184-.149.333-.333.333" stroke={colors.purple100} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.603 90.68a8.667 8.667 0 1 0-17.334 0"
        fill={colors.purple100}
      />
      <path d="M56.603 90.68a8.667 8.667 0 1 0-17.334 0" stroke={colors.purple100} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5 45a12.763 12.763 0 0 1 5.38-10.58.5.5 0 0 0-.3-.913c-6.19.216-11.098 5.298-11.098 11.493s4.907 11.277 11.099 11.493a.5.5 0 0 0 .3-.913A12.765 12.765 0 0 1 53.5 45Z"
        fill={colors.purple10}
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.5 51.5c-2.584-.01-3.87 1.375-4 4-.022-2.474-1.131-4-4-4 2.568-.035 3.989-1.275 4-4-.008 2.512 1.215 3.942 4 4Z"
        fill={colors.mustard10}
      />
      <path
        d="M69.5 51.5c-2.584-.01-3.87 1.375-4 4-.022-2.474-1.131-4-4-4 2.568-.035 3.989-1.275 4-4-.008 2.512 1.215 3.942 4 4"
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.5 41a2.231 2.231 0 0 0 2.5 2.5c-1.615-.006-2.418.86-2.5 2.5a2.211 2.211 0 0 0-2.5-2.5 2.232 2.232 0 0 0 2.5-2.5Z"
        fill={colors.mustard10}
      />
      <path
        d="M60.5 41a2.231 2.231 0 0 0 2.5 2.5c-1.615-.006-2.418.86-2.5 2.5a2.211 2.211 0 0 0-2.5-2.5 2.232 2.232 0 0 0 2.5-2.5"
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.5 34.5c-.006 1.885.912 2.957 3 3-1.938-.007-2.9 1.032-3 3-.016-1.856-.85-3-3-3 1.926-.025 2.992-.956 3-3Z"
        fill={colors.mustard10}
      />
      <path
        d="M67.5 34.5c-.006 1.885.912 2.957 3 3-1.938-.007-2.9 1.032-3 3-.016-1.856-.85-3-3-3 1.926-.025 2.992-.956 3-3"
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.306 53.126a3.5 3.5 0 0 0-3.649-4.626A6 6 0 0 0 29 50.485a5.515 5.515 0 0 0 0 11.03h13a4.516 4.516 0 0 0 2.306-8.389ZM102.306 53.126a3.501 3.501 0 0 0-3.649-4.626A6 6 0 0 0 87 50.485a5.515 5.515 0 0 0 0 11.03h13a4.516 4.516 0 0 0 2.306-8.389Z"
        fill={colors.cyan10}
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103 76a7 7 0 1 0-14 0v0a7 7 0 1 0 14 0Z"
        fill={colors.mustard10}
        stroke={colors.purple90}
      />
      <path
        d="M96 85v2M105 76h2M96 67v-2M87 76h-2M89.637 82.364l-1.415 1.415M102.364 82.364l1.414 1.414M102.365 69.637l1.414-1.414M89.636 69.637l-1.414-1.414"
        stroke={colors.purple90}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.204 60.084A2.333 2.333 0 0 0 82.771 57 4 4 0 0 0 75 58.323a3.677 3.677 0 0 0 0 7.354h8.667a3.01 3.01 0 0 0 1.537-5.593Z"
        fill={colors.cyan10}
        stroke={colors.purple90}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill={colors.white} d="M0 0h128v128H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);
